// Mappers for imageHandling-related entities
// Identity mappers for 1:1 mapping

import type {
  DocumentDto,
  DocumentUploadResponseDto,
  SearchImagesResponseDto,
  FilterDocumentsResponseDto,
  DocumentCategoryDto,
  DocumentUploadResponse2Dto,
} from '../../generated/models';

import type { SasResponse as SasResponseLocal } from '@api/modules/imageHandling/types';

import type {
  Document,
  DocumentUploadResponse,
  SearchImagesResponse,
  FilterDocumentsResponse,
  DocumentCategory,
  SasResponse,
  DocumentUploadResponse2,
  DocumentSearchResponse,
} from '../types';

// Response mappers (identity for 1:1)
export const toDocument = (dto: DocumentDto): Document => dto;
export const toDocumentArray = (dto: DocumentDto[]): Document[] => dto.map(toDocument);
// toDocumentSearchResponse — already in './search' mapper
export const toDocumentUploadResponse = (dto: DocumentUploadResponseDto): DocumentUploadResponse => dto;
export const toDocumentUploadResponse2 = (dto: DocumentUploadResponse2Dto): DocumentUploadResponse2 => dto;
export const toSearchImagesResponse = (dto: SearchImagesResponseDto): SearchImagesResponse => dto;
export const toFilterDocumentsResponse = (dto: FilterDocumentsResponseDto): FilterDocumentsResponse => dto;
export const toDocumentCategory = (dto: DocumentCategoryDto): DocumentCategory => dto;
export const toDocumentCategoryArray = (dto: DocumentCategoryDto[]): DocumentCategory[] => dto.map(toDocumentCategory);

// Local type mappers (identity for 1:1)
export const toSasResponse = (dto: SasResponseLocal): SasResponse => dto;
